import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import './index.css';
import rootReducer from './redux/reducers';
import App from './App';
export var store = createStore(rootReducer, applyMiddleware(thunk));
window.myStore = store;

var RahImageClassier = function RahImageClassier(_ref) {
  var game = _ref.game;
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(App, {
    game: game
  }));
};

export default RahImageClassier;